module.exports = __webpack_public_path__ + "img/ceo.b86d518.png";